import { NETWORKS, NETWORKS_CODES } from '@/utils/constants/networks'

export const myBusiness = {
    state: {
        dicts: null,
        news: null,
        termsStatus: 'idle',
        networks: []
    },
    mutations: {
        SET_MY_BUSINESS_DICTS(state, payload) {
            state.dicts = payload
        },

        SET_MY_BUSINESS_NEWS(state, payload) {
            state.news = payload
        },

        SET_MY_BUSINESS_NEWS_STATUS(state, payload) {
            state.termsStatus = payload
        },

        SET_MY_BUSINESS_NETWORKS(state, payload) {
            state.networks.push(payload)
        },

        RESET_MY_BUSINESS_NETWORKS(state) {
            state.networks = []
        },

        UPDATE_MY_BUSINESS_NETWORKS(state, payload) {
            state.networks = payload
        }
    },
    actions: {
        async loadMyBusinessDicts({ commit }) {
            try {
                const res = await this.$api.get('getMyBusinessDicts')

                if (!res.data?.data) {
                    return
                }
                commit('SET_MY_BUSINESS_DICTS', res.data.data)

                return res
            } catch (err) {
                console.log(err)
            }
        },

        async fetchMyBusiness({ state, dispatch, getters }, payload) {
            try {
                const params = payload.params || payload
                const config = payload.config || {}
                const userId = getters.userId

                const res = await this.$api.get(
                    `users/${userId}/myBusiness`,
                    {
                        params: {
                            ...params
                        },
                        ...config
                    }
                )

                return res
            } catch (err) {
                console.log(err)
            }
        },

        async loadMyBusinessTerms({ commit, dispatch }, payload) {
            try {
                commit('SET_MY_BUSINESS_NEWS_STATUS', 'loading')

                const res = await dispatch('fetchMyBusiness', payload)

                if (!res.data?.data) {
                    return
                }
                commit('SET_MY_BUSINESS_NEWS', res.data.data)

                return res
            } catch (err) {
                console.log(err)
            } finally {
                commit('SET_MY_BUSINESS_NEWS_STATUS', 'idle')
            }
        },

        async loadMyBusinessNetwork({ commit, dispatch }, payload) {
            try {
                const params = payload.params || payload
                const config = payload.config || {}

                // Fetch network sections
                const { data, status } = await dispatch('fetchMyBusiness', {
                    params,
                    config
                })

                if (status !== 200 || !data?.data) {
                    throw new Error(data.message || 'Error loadMyBusinessNetwork')
                }

                const section = data.data.sections[0]
                // Fallback object when section doesn't exist - code is required for proper display handling
                const networkData = section || { code: params.section }

                if (!payload?.setUnreadCount) {
                    commit('SET_MY_BUSINESS_NETWORKS', networkData)
                    return
                }

                // Fetch unread count
                const { data: unreadData, status: unreadStatus } = await dispatch('fetchMyBusiness', {
                    params: {
                        limit: 1,
                        read: false,
                        section: params.section
                    },
                    config
                })

                if (unreadStatus !== 200 || !unreadData?.data) {
                    commit('SET_MY_BUSINESS_NETWORKS', networkData)
                    throw new Error(unreadData.message || 'Error GET unread count')
                }

                const unreadCount = ((unreadData.data.sections[0] || {}).subsections || []).length

                commit('SET_MY_BUSINESS_NETWORKS', {
                    ...networkData,
                    unreadCount
                })
            } catch (err) {
                console.log(err)
            }
        },

        async loadAllNetworks({ commit, dispatch, getters }, payload) {
            const userNetworks = getters.getUserNetworks
                .filter(el => Object.values(NETWORKS).includes(el))
                .map(el => {
                    const code = el.split('_')[0]
                    return {
                        name: el,
                        code: NETWORKS_CODES[code]
                    }
                })

            await commit('RESET_MY_BUSINESS_NETWORKS')

            const promises = userNetworks.map(network => {
                return dispatch('loadMyBusinessNetwork', {
                    params: {
                        offset: 0,
                        limit: 100,
                        section: network.code
                    },
                    config: {
                        noCancel: true
                    },
                    setUnreadCount: userNetworks.length > 1
                })
            })

            await Promise.all(promises)
        },
        async markTermAsRead({ commit, getters }, payload) {
            try {
                const singleNews = payload?.sections[0]?.subsections[0]?.news[0]

                if (!singleNews || (singleNews && singleNews.read)) {
                    // If there's no news or news is already read, do nothing
                    return
                }
                const { status } = await this.$api.patch(
                    `users/${getters.userId}/myBusiness/${singleNews.id}`
                )
                if (status !== 200) {
                    throw new Error('Error markTermAsRead')
                }

                setTimeout(() => {
                    singleNews.read = true
                    commit('SET_MY_BUSINESS_NEWS', payload)

                    const networks = getters.getMyBusinessNetworks
                    const subsectionCode = payload.sections[0].subsections[0].code

                    const searchedSubsection = networks[0]?.subsections?.find(el =>
                        el.code === subsectionCode
                    )
                    const newsToUpdate = searchedSubsection?.news?.find(el =>
                        el.id === singleNews.id
                    )
                    if (newsToUpdate) {
                        newsToUpdate.read = true
                        commit('UPDATE_MY_BUSINESS_NETWORKS', networks)
                    }
                }, 2000)
            } catch (err) {
                console.log(err)
            }
        }
    },
    getters: {
        getMyBusinessDicts: state => state.dicts,
        getMyBusinessSections: state => {
            if (!state.dicts) return []
            return state.dicts.sections
        },
        getMyBusinessNews: state => state.news,
        getMyBusinessNewsStatus: state => state.newsStatus,
        getMyBusinessNetworks: state => state.networks
    }
}
